var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('loading') : _vm._e(), _vm.staff ? _c('div', {
    staticClass: "container mt-5"
  }, [!_vm.success ? _c('div', {
    attrs: {
      "id": "step1"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "p-3"
  }, [_c('b-card', {
    staticClass: "mt-3",
    attrs: {
      "img-src": _vm.getAvatar,
      "img-alt": "Image",
      "img-top": ""
    }
  }, [_c('a', {
    staticClass: "\n              list-item-heading\n              mb-1\n              truncate\n              text-primary\n              font-weight-bold\n            ",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" " + _vm._s(_vm.staff.name) + " ")]), _c('p', {
    staticClass: "mb-2 text-muted text-small"
  }, [_vm._v(" " + _vm._s(_vm.staff.service_unit) + _vm._s(_vm.staff.job_level) + " ")]), _c('button', {
    staticClass: "btn btn-xs btn-outline-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" " + _vm._s(_vm.staff.mobile_phone) + " ")])])], 1), _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('div', {
    staticClass: "h5"
  }, [_vm._v(" 將 "), _c('span', {
    staticClass: "text-primary px-2"
  }, [_vm._v(_vm._s(_vm.staff.name))]), _vm._v(" 設定為您的業務？ ")])]), _c('div', {
    staticClass: "d-flex justify-content-between mt-4"
  }, [_c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-dark mr-3 w-100",
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("否")]), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "primary w-100",
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.accept
    }
  }, [_vm._v("是")])], 1)]) : _c('div', {
    staticClass: "p-3",
    attrs: {
      "id": "step2"
    }
  }, [_c('b-card', {
    staticClass: "mt-3",
    attrs: {
      "img-src": _vm.getAvatar,
      "img-alt": "Image",
      "img-top": ""
    }
  }, [_c('div', {
    staticClass: "text-center font-weight-bolder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.staff.name))]), _c('h3', [_vm._v(_vm._s(_vm.staff.employee_code))]), _c('p', {
    staticClass: "text-muted text-small"
  }, [_vm._v(" " + _vm._s(_vm.staff.service_unit) + _vm._s(_vm.staff.job_level) + " ")])])]), _vm.staff ? _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('h5', [_vm._v("帳號綁定成功")])]) : _vm._e(), _c('div', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticClass: "mb-1 mt-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 回官方帳號 ")])], 1)], 1)]) : _vm._e()], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center mt-2"
  }, [_c('h1', {
    staticClass: "h5 font-weight-bold"
  }, [_vm._v("業務人員綁定")])]);
}]

export { render, staticRenderFns }